import { render, staticRenderFns } from "./LinkdialogOpener.vue?vue&type=template&id=5a9b0d42&scoped=true&"
import script from "./LinkdialogOpener.vue?vue&type=script&lang=js&"
export * from "./LinkdialogOpener.vue?vue&type=script&lang=js&"
import style0 from "./LinkdialogOpener.vue?vue&type=style&index=0&id=5a9b0d42&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9b0d42",
  null
  
)

export default component.exports